import { useEffect, useState } from 'react';

import { OrderSelectionStatus, useOrderSelectionQuery } from 'generated/graphql-gateway';

import {
  IUseShortCodePollStatus,
  IUseShortCodePollStatusParams,
  ShortCodePollingStatus,
} from './types';

export const useShortCodePollStatus = ({
  skipPolling,
  shortCode,
  pollInterval,
}: IUseShortCodePollStatusParams): IUseShortCodePollStatus => {
  const [pollingStatus, setPollingStatus] = useState<ShortCodePollingStatus>(
    ShortCodePollingStatus.None
  );

  const resetPollingStatus = () => {
    setPollingStatus(ShortCodePollingStatus.None);
  };

  // setting pending code state
  useEffect(() => {
    if (!skipPolling) {
      setPollingStatus(ShortCodePollingStatus.Pending);
    }
  }, [skipPolling]);

  const skip = skipPolling || !shortCode || pollingStatus === ShortCodePollingStatus.None;
  const { data: pollData } = useOrderSelectionQuery({
    variables: {
      otp: shortCode!,
    },
    fetchPolicy: 'no-cache',
    skip,
    // skip polling
    pollInterval: skip || pollingStatus === ShortCodePollingStatus.Confirmed ? 0 : pollInterval,
  });

  const pollStatus = pollData?.orderSelection?.status;
  useEffect(() => {
    if (pollStatus === OrderSelectionStatus.CLAIMED) {
      setPollingStatus(ShortCodePollingStatus.Confirmed);
    }
  }, [pollStatus]);

  return {
    pollingShortCodeStatus: pollingStatus,
    resetPollingStatus,
  };
};
